// removed by extract-text-webpack-plugin
module.exports = {"root":"WarningPopin-module-root-3kU5Q","popin-bg":"WarningPopin-module-popin-bg-1d1r5","popinBg":"WarningPopin-module-popin-bg-1d1r5","content":"WarningPopin-module-content-3_HWv","title":"WarningPopin-module-title-16ZAI","description":"WarningPopin-module-description-1zQ7m","checkbox-wrap":"WarningPopin-module-checkbox-wrap-216J3","checkboxWrap":"WarningPopin-module-checkbox-wrap-216J3","checkbox":"WarningPopin-module-checkbox-3tEmB","label":"WarningPopin-module-label-179VM","btn":"WarningPopin-module-btn-jtZXi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WarningPopin/WarningPopin.module.scss
// module id = 1267
// module chunks = 0